<template>
  <div class="wan-resources-upload-wrap">
    <!-- *资源分类 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">*资源分类</div>
      </div>

      <el-radio-group v-model="ruleForm.sysCateId" @change="getList(1)">
        <el-radio v-for="item in subClassList" :key="item.id" :label="item.id"
        >{{ item.name }}
        </el-radio>
      </el-radio-group>

<!--      <el-row :gutter="10">
        <el-col :span="8">
          <el-select
            v-model="ruleForm.sysCateId"
            clearable
            placeholder="全部大类"
            style="width: 100%"
            @change="changeProvince('sysCateId')"
          >
            <el-option
              v-for="item in customClassList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select
            v-model="ruleForm.sysSubCateId"
            clearable
            placeholder="全部子类"
            style="width: 100%"
            @change="changeProvince('sysSubCateId')"
          >
            <el-option
              v-for="item in subClassList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select
            v-model="ruleForm.resAscr"
            clearable
            placeholder="全部客户"
            style="width: 100%"
            @change="changeProvince('resAscr')"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.cusShortName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>-->

      <!-- *选择客户 -->
<!--      <div class="file-type-wrap" style="margin-top: 20px">
        <div class="title-wrap">
          <div class="title">*客户</div>
        </div>

        <el-radio-group v-model="ruleForm.resAscr" @change="getList(1)">
          <el-radio v-for="item in customerList" :key="item.id" :label="item.id"
          >{{ item.cusShortName }}
          </el-radio>
        </el-radio-group>
      </div>-->

      <!-- *选择资源格式 -->
      <div class="file-type-wrap" style="margin-top: 20px">
        <div class="title-wrap">
          <div class="title">*资源格式</div>
        </div>

        <el-radio-group v-model="ruleForm.fileType" @change="getList(1)">
          <el-radio v-for="item in fileTypeList" :key="item.id" :label="item.id"
            >{{ item.name }}
          </el-radio>
        </el-radio-group>
      </div>

      <el-row :gutter="10" style="margin-top: 20px">
        <el-col :span="20">
          <el-input
            v-model="ruleForm.searchValue"
            placeholder=""
            style="width: 100%"
            @keyup.enter.native="getList(1)"
          >
          </el-input>
        </el-col>
        <el-col :span="4">
          <div class="search-btn" @click="getList(1)">搜索</div>
        </el-col>
      </el-row>
    </div>

    <!-- 搜索结果 -->
    <div style="margin: 20px 0 15px">{{ total }}个搜索结果</div>

    <div class="el-list">
      <el-checkbox-group v-model="checkedList">
        <div
          v-for="(item, index) in list"
          :key="index"
          :style="{
            background: checkedList.includes(item.id) ? '#f1f5f8' : '#fcfdfe',
          }"
          class="el-list-item"
          @click="changeList(item, index)"
        >
          <img :src="item.coverUrl" alt="" />
          <div class="content">
            <span style="color: #acadae">{{ item.fileTypeName }} </span>
            <span>{{ item.resName }}</span>
          </div>
          <el-checkbox :label="item.id" />
        </div>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "pickResource",

  props: {
    parentCheckedList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      ruleForm: {
        sysSubCateId: "",
        sysCateId: "",
        fileType: "",
        searchValue: "",
        resAscr: "",
      },
      subClassList: [],
      customTypeList: [],
      customClassList: [],
      checkedList: [],
      fileTypeList: [],
      customerList: [],
      list: [],
      tempList: [],
      total: 0,
      page: 1,
    };
  },

  async created() {
    // 自定义分类
    this.customClassList = await this.$utils.getCustomContentCateList();
    this.subClassList = this.customClassList[0].subclassList
    // 获取文件类型
    this.fileTypeList = await this.$utils.getClassSetList();
    // 获取关联合作 客户
    this.customerList = await this.$utils.getCustomerList();

    this.getList(1);

    this.$bus.on("drawerScroll", (e) => {
      if (!this.$parent.$parent.$parent.$refs.pickDrawer.drawerVisible) return;
      this.scrollSearch(e);
    });
    this.checkedList = this.parentCheckedList.map((item) => item.id);
    this.tempList = this.parentCheckedList.map((item) => item);
  },

  methods: {
    changeProvince(type) {
      console.log(type, "type");
      if (type === "sysCateId") {
        this.ruleForm.sysSubCateId = "";
        this.subClassList = this.customClassList.filter(
          (item) => item.id === this.ruleForm.sysCateId
        )[0].subclassList;
      }

      this.getList(1);
    },

    // 滚动搜索
    scrollSearch(e) {
      let scrollBottom =
        e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;
      if (this.total <= this.list.length) return;
      if (scrollBottom === 0) {
        this.page++;
        this.getList();
      }
    },

    getList(page) {
      this.$store.commit("setLoading", true);
      this.$http
        .getResoureList({
          pageIndex: page ? 1 : this.page,
          pageSize: 10,
          condition: {
            ...this.ruleForm,
            spaceId: this.$store.state.userInfo.id,
            keyword: this.ruleForm.searchValue,
          },
        })
        .then(({ data }) => {
          // 条件查询不要累加
          if (page) this.list = data.result;
          else this.list = [...this.list, ...data.result];
          // 选中结果赋值
          this.total = data.total;
          this.$store.commit("setLoading", false);
        });
    },

    changeList(item, index) {
      console.log(item, index);
      if (this.checkedList.includes(item.id)) {
        this.checkedList.splice(this.checkedList.indexOf(item.id), 1);
        this.tempList.splice(this.checkedList.indexOf(item.id), 1);
      } else {
        this.checkedList.push(item.id);
        this.tempList.push(item);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search-btn {
  width: 100px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  line-height: 40px;
  text-align: center;
}

.el-list {
  .el-list-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    background: #fcfdfe;
    padding-right: 20px;
    box-sizing: border-box;

    img {
      width: 80px;
      height: 64px;
      flex: 0 0 80px;
      border-radius: 5px;
    }

    .content {
      flex: 1;
      margin-left: 12px;
      font-size: 16px;
      color: #000;
    }
  }

  /deep/ .el-checkbox {
    .el-checkbox__label {
      display: none;
    }

    .el-checkbox__inner {
      border-radius: 50%;
    }
  }
}
</style>
